import React from 'react';
import PropTypes from 'prop-types';
import APLogo from '../../../static/logos/ap.png';
import FLLogo from '../../../static/logos/frontline.png';
import PBSLogo from '../../../static/logos/pbs-wht.png';
import PBSLogoBlue from '../../../static/logos/pbs.png';
import './_logos.scss';

const Logos = ({ alt }) => (
  <div className="logos">
    <div className="logo logo--ap">
      <a href="https://apnews.com/" target="_blank" rel="noreferrer"><img src={APLogo} alt="AP Logo" /></a>
    </div>
    <div className="logo logo--frontline">
      <a href="https://www.pbs.org/wgbh/frontline/" target="_blank" rel="noreferrer"><img src={FLLogo} alt="FRONTLINE Logo" /></a>
    </div>
    <div className="logo logo--pbs">
      <a href="https://www.pbs.org/" target="_blank" rel="noreferrer"><img src={(alt ? PBSLogoBlue : PBSLogo)} alt="PBS Logo" /></a>
    </div>
  </div>
);

Logos.propTypes = {
  alt: PropTypes.bool,
};

Logos.defaultProps = {
  alt: false,
};

export default Logos;
